import { useQuery } from '@tanstack/react-query';
import type { ElasticBranding } from '@//app/api/search/brandings';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../../httpClient';

export const BRANDINGS_CACHE_KEY = 'api/search/brandings';

interface UseBrandingsSettings {
  initialData?: ElasticBranding[];
}

const useBrandings = (settings?: UseBrandingsSettings) => {
  const apiBaseUrl = useApiBaseUrl();
  const initialData = settings?.initialData;
  const query = useQuery<ElasticBranding[]>({
    queryKey: [BRANDINGS_CACHE_KEY],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/search/brandings`;
      return await httpClientGetJson<ElasticBranding[]>(url);
    },
    initialData,
    initialDataUpdatedAt: initialData ? Date.now() : undefined,
    staleTime: initialData ? 300_000 : 0,
    refetchOnMount: !initialData,
  });

  return query;
};

export default useBrandings;
